import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-surface flex items-center justify-center px-6">
      <div className="w-full max-w-md bg-white border border-border rounded-2xl p-10 shadow-[0_30px_80px_-50px_rgba(11,31,51,0.4)]">
        <div className="flex items-center gap-2.5 mb-8">
          <span className="w-8 h-8 bg-ink text-white flex items-center justify-center font-serif text-lg">L</span>
          <span className="font-serif text-xl text-ink">Local Proof STL</span>
        </div>
        <h1 className="font-serif text-3xl text-ink mb-2">Admin sign in</h1>
        <p className="text-steel text-sm mb-8">Manage insights and consultation requests.</p>
        <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
          <div>
            <Label htmlFor="email" className="text-charcoal">Email</Label>
            <Input id="email" type="email" data-testid="admin-email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2" />
          </div>
          <div>
            <Label htmlFor="password" className="text-charcoal">Password</Label>
            <Input id="password" type="password" data-testid="admin-password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2" />
          </div>
          {error && <p data-testid="admin-login-error" className="text-sm text-destructive">{error}</p>}
          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={loading}
            className="w-full bg-ink text-white py-3.5 rounded-full text-sm font-semibold hover:bg-charcoal transition-colors disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
